// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { validateToken } from "./validateToken.js";
// import { getCookie } from "./webStorage.js";
// import { useUser } from "./userProvider.js";
// import { ThemeProvider } from "./themeContext";
// import { InfiLoader } from "../components/loader.js";

// const ProtectedRoute = ({ element: Element, requiredPermission }) => {
//   const { setUser } = useUser();
//   const [isValidated, setIsValidated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // const token = getCookie("sctoken");
//     const token = getCookie("sctoken") || sessionStorage.getItem("loginToken");

//     if (!token) {
//       window.location.href = "/";
//     }

//     validateToken(token)
//       .then((user) => {
//         console.log("user PrivateRoute", user);
//         if (user?.success === true) {
//           setIsValidated(true);
//           setUser(user.user);
//         } else {
//           setIsValidated(false);
//         }
//       })
//       .catch((error) => {
//         console.error("Token validation failed:", error);
//         setIsValidated(false);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, []);

//   // useEffect(() => {
//   //   const checkAuth = async () => {
//   //     const token =
//   //       getCookie("sctoken") || sessionStorage.getItem("loginToken");

//   //     if (!token) {
//   //       window.location.href = "/";
//   //       return;
//   //     }

//   //     try {
//   //       const user = await validateToken(token);

//   //       if (user?.success) {
//   //         setIsValidated(true);
//   //         setUser(user.user);
//   //       } else {
//   //         setIsValidated(false);
//   //       }
//   //     } catch (error) {
//   //       console.error("Token validation failed:", error);
//   //       setIsValidated(false);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   checkAuth();
//   // }, [setUser]);

//   if (loading) {
//     return <InfiLoader maintext="Verifying.." />;
//   }
//   return isValidated ? (
//     <ThemeProvider>{Element}</ThemeProvider>
//   ) : (
//     <Navigate to="/unauthorized" />
//   );
// };

// export default ProtectedRoute;













import React, { useEffect, useState, useRef, useCallback } from "react";
import { Navigate } from "react-router-dom";
import { validateToken } from "./validateToken.js";
import { getCookie } from "./webStorage.js";
import { useUser } from "./userProvider.js";
import { ThemeProvider } from "./themeContext";
import { InfiLoader } from "../components/loader.js";

const ProtectedRoute = ({ element: Element }) => {
  const { setUser } = useUser();

  const [isValidated, setIsValidated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Prevent multiple API calls
  const hasValidated = useRef(false);

  // Stable version of setUser to satisfy ESLint
  const stableSetUser = useCallback((userData) => {
    setUser(userData);
  }, [setUser]);

  useEffect(() => {
    const token = getCookie("sctoken") || sessionStorage.getItem("loginToken");

    if (!token) {
      window.location.href = "/";
      return;
    }

    // Prevent duplicate validation calls
    if (hasValidated.current) return;
    hasValidated.current = true;

    validateToken(token)
      .then((response) => {
        if (response?.success === true) {
          stableSetUser(response.user);
          setIsValidated(true);
        } else {
          setIsValidated(false);
        }
      })
      .catch((error) => {
        console.error("Token validation failed:", error);
        setIsValidated(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [stableSetUser]); // ← Now ESLint is happy

  if (loading) {
    return <InfiLoader maintext="Verifying..." />;
  }

  return isValidated ? (
    <ThemeProvider>{Element}</ThemeProvider>
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default ProtectedRoute;